var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuppressionLists = function SvgSuppressionLists(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6C89",
    d: "M5.52 5.313a4.375 4.375 0 1 1 8.75 0 4.375 4.375 0 0 1-8.75 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6C89",
    fillRule: "evenodd",
    d: "M11.563 15.313a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0m1.81-.762a2.083 2.083 0 0 0 2.701 2.701zm1.178-1.178 2.701 2.7a2.083 2.083 0 0 0-2.701-2.701",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6C89",
    d: "M11.28 11.198c.363.086.544.13.588.263s-.093.293-.366.614a4.98 4.98 0 0 0-1.19 3.238c0 .949.265 1.836.725 2.592.28.463.421.694.35.822-.072.127-.32.127-.814.127H5.388c-1.515 0-2.686-.745-3.663-1.675-.565-.54-.847-1.146-.777-1.792.067-.609.432-1.105.817-1.481.615-.602 1.513-1.109 2.107-1.444q.205-.115.352-.202a9.4 9.4 0 0 1 3.501-1.229 9.6 9.6 0 0 1 3.554.167"
  })));
};
export default SvgSuppressionLists;